module.exports = __webpack_public_path__ + "static/media/dashboard_never_logged_in_icon.a4c3e644.png";